export default "__VITE_ASSET__fcaa991b__"